import request from '../utils/request'

export function getActivity (params) {
  return request.get('/project_crm/mobile/activityPage/searchById', {
    params
  })
}

export function getMsgCode (data) {
  return request.post('/project_crm/sms/get_code_by_geetest_token', {
    ...data,
    baseCode: true
  })
}

export function tencentFirm (data) {
  return request.post('/notify/invisibleCaptchaUseTencent', {
    ...data,
    baseCode: true
  })
}

export function authorityCheck (data) {
  return request.post('/project_crm/mobile/activityPage/receiveCouponByAuth_new', data)
}

export function getUserInfo (params) {
  return request.get('/appointment_platform/user/user/detail', {
    params
  })
}

export function familyUser (params) {
  return request.get('/project_family/member/user/detail', {
    params
  })
}

export function getTicket (data) {
  return request.post('/project_crm/mobile/activityPage/receiveCoupon_new', data)
}

export function login (data) {
  return request.post('/user_auth/wxLoginByPhone', {
    ...data,
    login: true
  })
}

// 获取路径参数
export function getActivityLinkParameter (params) {
  const xStreamId = localStorage.getItem('x-stream-id')
  return request.get('/project_crm/common/get_activity_link_parameter', { params: params, headers: { 'x-stream-id': xStreamId } })
}

export function addGuestInformation (data) {
  return request.post('/project_crm/mobile/guestInformation/add', data)
}
